/* unplugin-vue-components disabled */import { render } from "./kanshanVideo.vue?vue&type=template&id=1e51da3b&scoped=true"
import script from "./kanshanVideo.vue?vue&type=script&lang=js"
export * from "./kanshanVideo.vue?vue&type=script&lang=js"

import "./kanshanVideo.vue?vue&type=style&index=0&id=1e51da3b&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e51da3b"]])

export default __exports__